import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";

dayjs.extend(utc);
dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

export default dayjs;
